import React from 'react'
import { Link } from 'react-router-dom';
import Service_01 from '../../../assets/images/services/service-three-image-1.jpg';
import Service_02 from '../../../assets/images/services/service-three-image-2.jpg';
import Service_03 from '../../../assets/images/services/service-three-image-3.jpg';
import Service_04 from '../../../assets/images/services/service-three-image-4.jpg';

const Service = () => {
    return (
        <>
            <div className="service-section-three">
                <div className="container">
                    <div className="heading-box-two">
                        <h2
                            className="heading-title animate fadeInLeft wow"
                            data-wow-duration="1500ms"
                        >
                            We can inspire and Offer Different Services
                        </h2>
                        <Link
                            to="#"
                            className="btn btn-light btn-theme animate fadeInRight wow"
                            data-wow-duration="1500ms"
                        >
                            Get In Touch <span>+</span>
                        </Link>
                    </div>
                    <div className="service-box-outer-three">
                        <div className="row gutter-y-20">
                            <div
                                className="col-lg-3 col-md-6 animate fadeInUp wow"
                                data-wow-duration="1500ms"
                            >
                                <div className="service-box-three">
                                    <div className="service-image-three">
                                        <img
                                            src={Service_01}
                                            alt="service-image"
                                        />
                                    </div>
                                    <div className="service-details-three">
                                        <span>
                                            <svg
                                                width={30}
                                                height={31}
                                                viewBox="0 0 30 31"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M27.68 4.47998H2.16C1.51935 4.47998 1 4.99933 1 5.63998V23.04C1 23.6806 1.51935 24.2 2.16 24.2H27.68C28.3207 24.2 28.84 23.6806 28.84 23.04V5.63998C28.84 4.99933 28.3207 4.47998 27.68 4.47998Z"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M19.5605 24.2L24.2005 30"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.2806 24.2L5.64062 30"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.2793 14.9202V18.4002"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M14.9199 12.6001V18.4001"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M19.5605 10.2798V18.3998"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M14.9199 4.48V1"
                                                    stroke="white"
                                                    strokeWidth="1.70588"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <h4>
                                            <Link to="/Services">Business Analysis</Link>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-3 col-md-6 animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="service-box-three">
                                    <div className="service-image-three">
                                        <img
                                            src={Service_02}
                                            alt="service-image"
                                        />
                                    </div>
                                    <div className="service-details-three">
                                        <span>
                                            <svg
                                                width={42}
                                                height={42}
                                                viewBox="0 0 42 42"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M23.625 5.25H18.375C17.6501 5.25 17.0625 5.83763 17.0625 6.5625V11.8125C17.0625 12.5374 17.6501 13.125 18.375 13.125H23.625C24.3499 13.125 24.9375 12.5374 24.9375 11.8125V6.5625C24.9375 5.83763 24.3499 5.25 23.625 5.25Z"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M13.125 27.5625H7.875C7.15013 27.5625 6.5625 28.1501 6.5625 28.875V34.125C6.5625 34.8499 7.15013 35.4375 7.875 35.4375H13.125C13.8499 35.4375 14.4375 34.8499 14.4375 34.125V28.875C14.4375 28.1501 13.8499 27.5625 13.125 27.5625Z"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M34.125 27.5625H28.875C28.1501 27.5625 27.5625 28.1501 27.5625 28.875V34.125C27.5625 34.8499 28.1501 35.4375 28.875 35.4375H34.125C34.8499 35.4375 35.4375 34.8499 35.4375 34.125V28.875C35.4375 28.1501 34.8499 27.5625 34.125 27.5625Z"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M21 13.125V19.6875"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M31.5 19.6875V27.5625"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.5 27.5625V19.6875"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M3.9375 19.6875H38.0625"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <h4>
                                            <Link to="/Services">Work organization</Link>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-3 col-md-6 animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="service-box-three">
                                    <div className="service-image-three">
                                        <img
                                            src={Service_03}
                                            alt="service-image"
                                        />
                                    </div>
                                    <div className="service-details-three">
                                        <span>
                                            <svg
                                                width={33}
                                                height={30}
                                                viewBox="0 0 33 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M4.57874 21.9018C4.33805 21.8965 4.10557 21.8133 3.91619 21.6646C3.72682 21.516 3.59076 21.3099 3.52845 21.0774L2.23253 16.2409C2.17022 16.0084 2.18502 15.7619 2.2747 15.5385C2.36438 15.3151 2.5241 15.1268 2.7299 15.0018L24.4307 1.41161C24.5784 1.32197 24.7449 1.26794 24.9171 1.2538C25.0892 1.23966 25.2623 1.2658 25.4226 1.33014C25.5829 1.39449 25.726 1.49527 25.8406 1.62452C25.9553 1.75376 26.0382 1.90791 26.0829 2.07476L31.2666 21.4204C31.3113 21.5873 31.3165 21.7623 31.2819 21.9315C31.2473 22.1007 31.1737 22.2596 31.067 22.3954C30.9604 22.5313 30.8236 22.6405 30.6674 22.7143C30.5112 22.7882 30.34 22.8246 30.1673 22.8208L4.57874 21.9018Z"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M9.55561 22.0798L10.845 26.8921C10.9214 27.1771 11.1079 27.4202 11.3635 27.5677C11.619 27.7153 11.9227 27.7552 12.2078 27.6789L16.5068 26.5269C16.7919 26.4506 17.0349 26.2641 17.1825 26.0085C17.33 25.753 17.37 25.4492 17.2936 25.1642L12.8691 8.65186"
                                                    stroke="white"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <h4>
                                            <Link to="/Services">Digital marketing</Link>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-3 col-md-6 animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="service-box-three">
                                    <div className="service-image-three">
                                        <img
                                            src={Service_04}
                                            alt="service-image"
                                        />
                                    </div>
                                    <div className="service-details-three">
                                        <span>
                                            <svg
                                                width={35}
                                                height={35}
                                                viewBox="0 0 35 35"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.07804 32.2735L9.74292 8.44874C9.81661 8.2452 9.94049 8.06357 10.1031 7.92068C10.2657 7.77779 10.4618 7.67828 10.6731 7.63137C10.8844 7.58447 11.1041 7.59169 11.3119 7.65236C11.5197 7.71304 11.7088 7.8252 11.8617 7.97845L27.0232 23.1399C27.176 23.293 27.2878 23.4821 27.3481 23.6897C27.4085 23.8974 27.4154 24.117 27.3684 24.3281C27.3213 24.5391 27.2218 24.7349 27.0789 24.8973C26.9361 25.0597 26.7546 25.1835 26.5513 25.2571L2.72653 33.922C2.49645 34.006 2.24715 34.0226 2.00797 33.9697C1.7688 33.9168 1.54971 33.7967 1.3765 33.6235C1.2033 33.4503 1.08318 33.2312 1.03031 32.992C0.977431 32.7528 0.993992 32.5035 1.07804 32.2735Z"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M22.1191 10.2407C22.1191 10.2407 22.1191 6.2804 26.0795 6.2804C30.0398 6.2804 30.0398 2.32007 30.0398 2.32007"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M18.1582 1V4.96034"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M30.0391 16.8416L32.6793 19.4818"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M30.0391 11.5608L33.9994 10.2407"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M7.28223 15.2061L19.7936 27.7174"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M11.0811 30.8856L4.11426 23.9187"
                                                    stroke="white"
                                                    strokeWidth={2}
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <h4>
                                            <Link to="/Services">Innovation space</Link>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Service
